export const FIELDS_DESCRIPTOR = {
  'sistematica': {},
  'impianto': {},
  'piattaforma': {},
  'collo': {},
  'chiusura': { restricted: true },
  'tipo_scan_abutment': {},
  'scan_abutment': { autocomplete: true },
  'indicazioni_uso': { autocomplete: true, restrictionsIssuer: true },
  'tecnica': {},
  'foro': {},
  'battuta': {},
  'materiale': { extraInfo: true },
  'materia_prima': { extraInfo: true },
  'colore': {},
  'interfaccia': {},
  't_connect': {},
  'angolazione': {},
  'h_cono': {},
  'transmucosa': {},
  'codice_interfaccia': {},
  'vite': {}
}
